import React, { FC, ReactEventHandler } from 'react'
import { EyeOpenedIcon } from './components/EyeOpenedIcon'
import { EyeClosedIcon } from './components/EyeClosedIcon'
import style from './EyeButton.module.css'

type EyeButtonProps = {
  isOpen?: boolean
  onClick: ReactEventHandler
}

export const EyeButton: FC<EyeButtonProps> = ({ isOpen = false, onClick }) => {
  return (
    <button type="button" tabIndex={0} className={style.eye} onClick={onClick}>
      {isOpen ? <EyeOpenedIcon /> : <EyeClosedIcon />}
    </button>
  )
}
